import React, { useState } from 'react';
import axiosInstance from '../../api/axiosInstance'; // Import your pre-configured Axios instance
import './UploadSection.css';

const UploadSection = ({ title, apiEndpoint, onUploadSuccess }) => {
  const [selectedFile, setSelectedFile] = useState(null);
  const [status, setStatus] = useState({ message: '', isUploading: false });

  const handleUpload = async (e) => {
    e.preventDefault();

    if (!selectedFile) {
      setStatus({ message: `Please select a ${title.toLowerCase()} to upload.` });
      return;
    }

    const formData = new FormData();
    formData.append(title.replace(' ', ''), selectedFile);

    try {
      setStatus({ message: '', isUploading: true });

      // Use your pre-configured Axios instance
      const response = await axiosInstance.post(apiEndpoint, formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
      });

      setSelectedFile(null);
      setStatus({ message: `${title} uploaded successfully.`, isUploading: false });

      // Notify parent of successful upload
      if (onUploadSuccess) {
        onUploadSuccess(response.data.path);
      }
    } catch (error) {
      if (error.code === 'ECONNABORTED') {
        setStatus({ message: 'Request timed out. Please try again.', isUploading: false });
      } else {
        console.error('Upload failed:', error);
        setStatus({ message: `Error uploading ${title.toLowerCase()}.`, isUploading: false });
      }
    }
  };

  return (
    <div className="upload-section">
      <h2>Update {title}</h2>
      <form onSubmit={handleUpload}>
        <input
          type="file"
          accept="image/*"
          onChange={(e) => setSelectedFile(e.target.files[0])}
        />
        <button type="submit" disabled={status.isUploading}>
          {status.isUploading ? 'Uploading...' : `Upload ${title}`}
        </button>
      </form>
      {status.message && <p>{status.message}</p>}
    </div>
  );
};

export default UploadSection;
